export default __webpack_public_path__ + "static/media/1-2.0b52e11e.jpeg";